import { normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass({ 'progress-bar green stripes': true, 'narrow-height': _ctx.narrow }),
    style: _normalizeStyle(`width: ${_ctx.width ? _ctx.width : (_ctx.allowNullWidth ? 0 : 100)}px;`)
  }, [
    _createElementVNode("span", {
      style: _normalizeStyle(`width: ${_ctx.realPercent}%;`)
    }, null, 4)
  ], 6))
}